import { Box, Collapse, Divider, List, ListItemText, Menu, Stack, Typography, useTheme } from '@mui/material';
import { map } from 'lodash';
import { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { Link } from 'react-router-dom';
import { CustomMenuIcon } from 'src/components/Drawer/Common';
import { IMenuItem } from 'src/components/Drawer/SidebarMenu';
import { ListItem, ListItemButton, ListItemIcon } from 'src/components/Drawer/SidebarStyled';

const MenuItemSubMenu = ({
  menu,
  open,
  checkIsSelected,
}: {
  menu: IMenuItem;
  open: boolean;
  checkIsSelected: (activePaths?: string[]) => boolean;
}) => {
  const isSelected = checkIsSelected(menu.activePaths);
  const [isExpand, setIsExpand] = useState(isSelected);
  const [anchorEl, setAnchorEl] = useState<null | Element>(null);

  useEffect(() => {
    if (!open) {
      setIsExpand(false);
    }
  }, [open]);

  const {
    palette: { text, divider },
  } = useTheme();

  const renderIconExpand = () => {
    if (!open) return null;

    if (isExpand) {
      return (
        <ListItemIcon>
          <ChevronUp size={20} />
        </ListItemIcon>
      );
    } else {
      return (
        <ListItemIcon>
          <ChevronDown size={20} />
        </ListItemIcon>
      );
    }
  };

  const renderPopupMenu = () => {
    return (
      <Menu
        sx={{ ml: 1 }}
        id="menu-header"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <Typography pl={3} color={'primary.main'} variant="subtitle2">
          {menu.text}
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Box px={1}>
          <List sx={{ padding: 0 }}>
            <Stack>
              {map(menu.submenu, ({ path, text, disabled, activePaths }) => {
                const isSelectedSubMenu = checkIsSelected(activePaths);
                return (
                  <Link
                    to={{
                      pathname: path,
                    }}
                  >
                    <ListItemButton disabled={disabled} sx={{ py: 1, px: 2 }} selected={isSelectedSubMenu}>
                      <ListItemText
                        primary={
                          <Typography color="text.secondary" variant="subtitle2">
                            {text}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                  </Link>
                );
              })}
            </Stack>
          </List>
        </Box>
      </Menu>
    );
  };

  return (
    <>
      {renderPopupMenu()}
      <ListItem
        key={menu.key}
        sx={{ width: open ? '100%' : 'fit-content', marginLeft: 0, marginRight: 0 }}
        disablePadding={true}
      >
        <ListItemButton
          sx={{
            justifyContent: 'flex-start',
            padding: 1,
            color: text.secondary,
          }}
          disabled={menu.disabled}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            if (!open) {
              setAnchorEl(e.currentTarget);
              return;
            }
            setIsExpand(!isExpand);
          }}
        >
          <CustomMenuIcon Icon={menu.icon} handleOnclick={() => menu.onClickFn} isSelected={isSelected} />
          {open && (
            <ListItemText
              sx={{ pl: 1 }}
              primary={
                <Typography color={isSelected ? 'primary.main' : 'text.secondary'} variant="subtitle2">
                  {menu.text}
                </Typography>
              }
            />
          )}
          {renderIconExpand()}
        </ListItemButton>
      </ListItem>
      <Collapse in={isExpand && open} timeout="auto" unmountOnExit>
        <List sx={{ mt: -1 }}>
          <Stack borderLeft={'1px solid' + divider} pl={1} ml={1.5} spacing={1}>
            {map(menu.submenu, ({ path, text, disabled, activePaths }) => {
              const isActive = checkIsSelected(activePaths);
              return (
                <Link
                  to={{
                    pathname: path,
                  }}
                >
                  <ListItemButton disabled={disabled} sx={{ py: 1, px: 2 }} selected={isActive}>
                    <ListItemText
                      primary={
                        <Typography color="text.secondary" variant="subtitle2">
                          {text}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </Link>
              );
            })}
          </Stack>
        </List>
      </Collapse>
    </>
  );
};

export default MenuItemSubMenu;
